import { render, staticRenderFns } from "./LeagueGameModal.vue?vue&type=template&id=31ca8450&"
import script from "./LeagueGameModal.vue?vue&type=script&lang=js&"
export * from "./LeagueGameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports